// extracted by mini-css-extract-plugin
module.exports = {"page-alert-container":"page-alert-container__Dcewt","page-alert":"page-alert__DFLig","close-button":"close-button___aRdX"};